function setImageStyle(defaultConfig) {

  function setImageStyleData(calcState, data) {
    let cropCss = {};
    const cropFocus = data.info.cropfocus;
    setDivRectSize(calcState, data);
    setImageRectSize(data, calcState.widthRatio);
    const cropSize = getCropSize(data);
    setHorizontalCropCss(cropCss, cropFocus, cropSize);

    if (data.fixed) {
      revertImageSizeOnFixedDiv(data, cropCss);
    } else {
      zoomImagesBiggerThanDiv(calcState, data, (cropSize) => {
        cropCss = {};
        setHorizontalCropCss(cropCss, cropFocus, cropSize);
      });
    }

    data.css = cropCss;
    data.hide = 'N';
  }

  function setDivRectSize(calcState, data) {
    data.dw = !data.fixed ?
      data.w - (calcState.calcWidth + defaultConfig.imageDivMargin) :
      defaultConfig.fixedImageDivWidth;
    data.dh = calcState.calcDivHeight;
  }

  function setImageRectSize(data, ratio) {
    data.iw = Math.round(data.w - data.w * ratio);
    data.ih = Math.round(data.h - data.h * ratio);
  }

  function setHorizontalCropCss(cropCss, cropfocus, cropSize) {
    switch (cropfocus) {
      case 'left':
        cropCss.marginLeft = '0px';
        break;
      case 'right':
        cropCss.marginLeft = `-${cropSize * 2}px`;
        break;
      default:
        cropCss.marginLeft = `-${cropSize}px`;
    }
  }

  function setVeticalCropCss(cropCss, data) {
    cropCss.marginTop = Math.round((data.dh - data.ih) * 0.5) + 'px';
  }

  function revertImageSizeOnFixedDiv(data, cropCss) {
    data.iw = data.w;
    data.ih = data.h;
    if (data.dh > data.ih) {
      setVeticalCropCss(cropCss, data);
    }
  }

  function zoomImagesBiggerThanDiv(calcState, data, callback) {
    const calcDh = calcState.calcDivHeight;
    const zoomSize = calcDh - data.ih;
    if (zoomSize > 0) {
      data.iw = data.iw + Math.round(data.iw * zoomSize / data.ih);
      data.ih = calcDh;

      const cropSize = getCropSize(data);
      if (cropSize > 0) {
        callback(cropSize);
      }
    }
  }

  function getCropSize(data) {
    return Math.floor((data.iw - data.dw) / 2);
  }

  return setImageStyleData;
}

export default setImageStyle;


/** WEBPACK FOOTER **
 ** ./src/IIM/core/thumb_board/image_calculator/set_image_style.js
 **/